<div [style.background-color]="handleBgColor()"  [class.ms-2]="this.addMarginLeft" class="iconBg">
    <i class="{{this.handleIcon()}}" [class.me-1]="this.showText"></i>
    <p *ngIf="this.showText" class="mb-0">{{this.label}}</p>
</div>
